// Shared cache/hook for /api/business-settings.
// Antes desta consolidação, 3 callers independentes (ThemeLoader, SimulatorPage
// para snapshot_colors, AgencySelector em FormWidgets) faziam GETs separados,
// gerando 3 RTTs em prod e até 5 em dev (StrictMode). Este módulo garante um
// único GET por sessão (in-flight de-dup via promise).

import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _cache = null;
let _promise = null;

export function fetchBusinessSettings() {
  if (_cache) return Promise.resolve(_cache);
  if (_promise) return _promise;
  _promise = axios.get(`${API}/business-settings`)
    .then((res) => { _cache = res.data || {}; return _cache; })
    .catch(() => ({}))
    .finally(() => { _promise = null; });
  return _promise;
}

/**
 * Invalida o cache (usar depois de guardar em Admin → Configurações de Negócio).
 */
export function invalidateBusinessSettings() {
  _cache = null;
  _promise = null;
}

export function useBusinessSettings() {
  const [data, setData] = useState(_cache);
  useEffect(() => {
    let alive = true;
    fetchBusinessSettings().then((d) => {
      if (alive) setData(d);
    });
    return () => { alive = false; };
  }, []);
  return data;
}
